import { render, staticRenderFns } from "./ListarOrdensJudiciaisModal.vue?vue&type=template&id=8ae7cf96&"
import script from "./ListarOrdensJudiciaisModal.vue?vue&type=script&lang=js&"
export * from "./ListarOrdensJudiciaisModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports